(() => {
  const STYLE_ID = 'kp-mobile-collage-carousel-style';
  const TARGET_SECTION_KEYS = ['__what_can_see', '__who_its_for'];
  const TARGET_HEADINGS = ['what can you see', 'who is this telescope for'];

  const css = `
    @media (max-width: 749px) {
      .kp-mobile-collage .kp-mobile-collage-track {
        display: flex !important;
        grid-template-columns: none !important;
        gap: 0 !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scroll-snap-type: x mandatory;
        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        height: clamp(300px, 82vw, 430px);
        border-radius: var(--rounded-block, 24px);
      }

      .kp-mobile-collage .kp-mobile-collage-track::-webkit-scrollbar { display: none; }

      .kp-mobile-collage .kp-mobile-collage-track > .collage-left,
      .kp-mobile-collage .kp-mobile-collage-track > .collage-right {
        display: contents !important;
      }

      .kp-mobile-collage .kp-mobile-collage-track > .collage-left > *,
      .kp-mobile-collage .kp-mobile-collage-track > .collage-right > * {
        flex: 0 0 100% !important;
        width: 100% !important;
        max-width: 100% !important;
        height: 100% !important;
        scroll-snap-align: start;
        scroll-snap-stop: always;
        margin: 0 !important;
      }

      .kp-mobile-collage .kp-mobile-collage-track .media,
      .kp-mobile-collage .kp-mobile-collage-track .media-card,
      .kp-mobile-collage .kp-mobile-collage-track .media-card__image,
      .kp-mobile-collage .kp-mobile-collage-track picture,
      .kp-mobile-collage .kp-mobile-collage-track a,
      .kp-mobile-collage .kp-mobile-collage-track div[class*='media'] {
        height: 100%;
      }

      .kp-mobile-collage .kp-mobile-collage-track img,
      .kp-mobile-collage .kp-mobile-collage-track video,
      .kp-mobile-collage .kp-mobile-collage-track svg {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .kp-mobile-collage .kp-mobile-collage-controls {
        display: grid;
        grid-template-columns: 42px minmax(0, 1fr) 42px;
        align-items: center;
        gap: 10px;
        margin-top: 14px;
      }

      .kp-mobile-collage .kp-mobile-collage-arrow {
        width: 42px;
        height: 42px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid rgba(var(--color-foreground), .12);
        border-radius: 999px;
        background: rgb(var(--color-background));
        color: rgb(var(--color-foreground));
        box-shadow: 0 10px 28px rgba(19, 38, 61, .08);
        font-size: 22px;
        line-height: 1;
      }

      .kp-mobile-collage .kp-mobile-collage-thumbs {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: 8px;
        min-width: 0;
      }

      .kp-mobile-collage .kp-mobile-collage-thumb {
        position: relative;
        display: block;
        height: 58px;
        padding: 0;
        overflow: hidden;
        border: 1px solid rgba(var(--color-foreground), .12);
        border-radius: 12px;
        background: rgba(var(--color-foreground), .04);
        opacity: .58;
        transition: opacity .18s ease, border-color .18s ease, transform .18s ease;
      }

      .kp-mobile-collage .kp-mobile-collage-thumb.is-active {
        opacity: 1;
        border-color: rgb(var(--color-foreground));
        transform: translateY(-1px);
      }

      .kp-mobile-collage .kp-mobile-collage-thumb img,
      .kp-mobile-collage .kp-mobile-collage-thumb svg {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .kp-mobile-collage .kp-mobile-collage-thumb span {
        position: absolute;
        inset: 0;
        display: grid;
        place-items: center;
        font-size: 11px;
        font-weight: 700;
        color: rgba(var(--color-foreground), .7);
      }
    }

    @media (min-width: 750px) {
      .kp-mobile-collage .kp-mobile-collage-controls { display: none !important; }
    }
  `;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function normalize(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function isTargetSection(section) {
    const sectionId = section.id || '';
    if (TARGET_SECTION_KEYS.some((key) => sectionId.includes(key))) return true;
    const heading = normalize(section.querySelector('.section-heading h1, .section-heading h2, .section-heading h3, .section-heading .heading, h2.heading, h2, h3')?.textContent);
    return TARGET_HEADINGS.some((target) => heading.includes(target));
  }

  function getSlides(track) {
    return [...track.querySelectorAll(':scope > .collage-left > *, :scope > .collage-right > *')];
  }

  function cloneThumbFromSlide(slide, index) {
    const button = document.createElement('button');
    button.className = `kp-mobile-collage-thumb${index === 0 ? ' is-active' : ''}`;
    button.type = 'button';
    button.setAttribute('aria-label', `Show image ${index + 1}`);

    const image = slide.querySelector('img');
    const svg = slide.querySelector('svg');
    if (image) {
      const thumb = image.cloneNode(true);
      thumb.removeAttribute('srcset');
      thumb.removeAttribute('sizes');
      thumb.loading = 'lazy';
      button.appendChild(thumb);
    } else if (svg) {
      button.appendChild(svg.cloneNode(true));
    } else {
      const fallback = document.createElement('span');
      fallback.textContent = index + 1;
      button.appendChild(fallback);
    }
    return button;
  }

  function setupSection(section) {
    if (section.dataset.kpMobileCollageReady === '1') return;
    if (!isTargetSection(section)) return;

    const collage = section.querySelector('.collage');
    if (!collage) return;

    const track = [...collage.children].find((child) => child.classList?.contains('grid') && child.querySelector('.collage-left, .collage-right'));
    if (!track) return;

    const slides = getSlides(track);
    if (slides.length < 2) return;

    section.dataset.kpMobileCollageReady = '1';
    section.classList.add('kp-mobile-collage');
    track.classList.add('kp-mobile-collage-track');

    const controls = document.createElement('div');
    controls.className = 'kp-mobile-collage-controls';
    controls.innerHTML = `
      <button class="kp-mobile-collage-arrow" type="button" aria-label="Previous image">‹</button>
      <div class="kp-mobile-collage-thumbs" aria-label="Image thumbnails"></div>
      <button class="kp-mobile-collage-arrow" type="button" aria-label="Next image">›</button>
    `;
    track.insertAdjacentElement('afterend', controls);

    const prev = controls.querySelector('.kp-mobile-collage-arrow:first-child');
    const next = controls.querySelector('.kp-mobile-collage-arrow:last-child');
    const thumbsWrap = controls.querySelector('.kp-mobile-collage-thumbs');
    const thumbs = slides.map((slide, index) => {
      const thumb = cloneThumbFromSlide(slide, index);
      thumb.addEventListener('click', () => goTo(index));
      thumbsWrap.appendChild(thumb);
      return thumb;
    });

    const currentIndex = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const goTo = (index) => {
      const nextIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: nextIndex * track.clientWidth, behavior: 'smooth' });
    };
    const updateThumbs = () => {
      const active = Math.min(slides.length - 1, Math.max(0, currentIndex()));
      thumbs.forEach((thumb, index) => thumb.classList.toggle('is-active', index === active));
    };

    prev.addEventListener('click', () => goTo(currentIndex() - 1));
    next.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(updateThumbs), { passive: true });
    window.addEventListener('resize', updateThumbs, { passive: true });
  }

  function init() {
    injectStyle();
    document.querySelectorAll('[id^="shopify-section-"]').forEach(setupSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
